var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 21,
  viewBox: "0 0 25 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.737 20.224c9.289 0 14.368-7.69 14.368-14.345 0-.212 0-.447-.024-.658.988-.706 1.835-1.6 2.517-2.61-.918.399-1.905.681-2.893.775a5.033 5.033 0 002.21-2.798 9.8 9.8 0 01-3.198 1.223c-1.904-2.023-5.102-2.117-7.148-.212-1.317 1.223-1.858 3.057-1.458 4.82A14.325 14.325 0 011.717 1.153a5.053 5.053 0 001.575 6.75 4.893 4.893 0 01-2.28-.636v.071a5.036 5.036 0 004.044 4.938 4.995 4.995 0 01-2.281.094 5.072 5.072 0 004.727 3.528 10.115 10.115 0 01-6.28 2.163c-.399 0-.799-.023-1.198-.07a14.324 14.324 0 007.713 2.234",
  fill: "currentColor",
  fillRule: "nonzero"
})));

export default SvgIconTwitter;